import React from 'react';
import { Eye, Lock, UserPlus, LogIn } from 'lucide-react';

interface GuestModeProps {
  onLogin: () => void;
  onSignup: () => void;
}

const GuestMode: React.FC<GuestModeProps> = ({ onLogin, onSignup }) => {
  return (
    <div className="mb-6">
      <div className="flex gap-2">
        <button
          onClick={onLogin}
          className="flex-1 flex items-center justify-center px-3 py-2.5 bg-gray-900 text-white rounded-md hover:bg-gray-700 transition-colors text-sm font-medium"
        >
          <LogIn className="w-4 h-4 mr-1.5" />
          로그인
        </button>
        <button
          onClick={onSignup}
          className="flex-1 flex items-center justify-center px-3 py-2.5 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors text-sm font-medium"
        >
          <UserPlus className="w-4 h-4 mr-1.5" />
          회원가입
        </button>
      </div>
    </div>
  );
};

export default GuestMode;
